"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _actions = require("./actions");

var _impressions = require("../shared/actions/impressions");

/**
 */
var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    preventPageviewReset: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _actions.IMPRESSION_REPORTED:
      return (0, _objectSpread3.default)((0, _objectSpread3.default)({}, state), {}, (0, _defineProperty2.default)({}, action.elementId, action.eventData || true));

    case _impressions.PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW:
      return (0, _objectSpread3.default)((0, _objectSpread3.default)({}, state), {}, {
        preventPageviewReset: true
      });

    case _actions.RESET_IMPRESSONS:
    case _actions.UPDATE_HISTORY:
    case _actions.LOCATION_CHANGE:
    case _actions.UPDATE_PATH:
      // Manually prevent reset for navigation that doesn't warrant a new pageview
      if (state.preventPageviewReset) {
        return state;
      } // Impressions are tied to a pageview, so in-app transition should
      // let all impressions occur again


      return {};

    default:
      return state;
  }
};

exports.default = _default;